<template>
  <sidebar-menu
      v-if="showShell"
      :menu="menu"
  />
  <div :class="showShell ? 'content' : 'auth-content'">
    <div v-if="showShell" class="main-title">
      <span>Сервис ротации в SCRUM-процессах</span>
      <button v-if="userEmail" class="logout" type="button" @click="logout">{{ userEmail }} · Выйти</button>
    </div>
    <router-view @teams-changed="reloadTeams"/>
  </div>
</template>

<style src="@fortawesome/fontawesome-free/css/all.css"></style>
<script>
import grpc from "@/services/grpc";
import AuthService from "@/services/auth";
import {useTokenStore} from "@/stores/token";

class Team {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }
}


export default {
  name: 'App',
  created() {
    this.reloadTeams()
  },
  watch: {
    '$route'() {
      this.reloadTeams();
    }
  },
  computed: {
    showShell() {
      return !this.$route.meta.public;
    },
    userEmail() {
      const user = useTokenStore().user;
      return user ? user.email : '';
    }
  },
  data() {
    return {
      grpcClient: new grpc(),
      auth: new AuthService(),
      menu: [],
    };
  },
  methods: {
    async reloadTeams() {
      if (!this.showShell) {
        return;
      }
      try {
        await this.getTeams();
        this.menu = this.getMenu();
      } catch (err) {
        console.error(err);
      }
    },
    async logout() {
      await this.auth.logout();
      await this.$router.push('/login');
    },
    async getTeams() {
      const teams = await this.grpcClient.getTeams();
      const teamsResponse = [];
      for (let team of teams) {
        const teamToAdd = new Team(team.getId(), team.getName());
        teamsResponse.push(teamToAdd);
      }
      this.addTeamsToLocalStorage(teamsResponse);
    },
    addTeamsToLocalStorage(teams) {
      localStorage.setItem('teams', JSON.stringify(teams));
    },
    fillTeamsFromLocalStorage(teams) {
      const jsonData = localStorage.getItem('teams');
      if (jsonData != null && jsonData.length > 0) {
        const sidebarTeams = JSON.parse(jsonData);
        for (let team of sidebarTeams) {
          const teamMenuElement = {
            href: '/teams/' + team.id,
            title: team.name,
            icon: 'fa-solid fa-user'
          };
          teams.push(teamMenuElement);
        }
      }
    },
    getMenu() {
      const teams = [];
      const addTeamElement = {
        href: '/teams/add',
        title: '+ добавить команду',
        icon: 'fa-solid fa-user-plus'
      };
      this.fillTeamsFromLocalStorage(teams);
      teams.push(addTeamElement);
      const items = [
        {
          header: 'Меню',
          hiddenOnCollapse: true
        },
        {
          href: '/',
          title: 'Главная',
          icon: 'fa-solid fa-house'
        },
        {
          href: '/teams',
          title: 'Команды',
          icon: 'fa-solid fa-people-group',
          child: teams
        },
        {
          href: '/meeting-types',
          title: 'Типы встреч',
          icon: 'fa-solid fa-handshake',
        }
      ];
      const user = useTokenStore().user;
      const canManageAccess = user && (user.isAdmin || (user.teams || []).some(team => team.role === 'owner'));
      if (canManageAccess) {
        items.push({
          href: '/access',
          title: 'Доступы',
          icon: 'fa-solid fa-user-lock'
        });
      }
      return items;
    }
  }
}

</script>

<style lang="scss">
body{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: row;
}

.v-sidebar-menu.vsm_expanded + .content {
  padding-left: 290px;
}

.v-sidebar-menu.vsm_collapsed + .content {
  padding-left: 65px;
}

.content {
  flex: 1;
}

.main-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background: $green-8;
  margin-top: 0;
  padding: 12px 24px;
  color: white;
  text-shadow: 1px 1px rgb(0 0 0 / 38%);
}

.logout {
  border: 0;
  background: transparent;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

.auth-content {
  width: 100%;
}
</style>
